import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { comparisonTableFeature, comparisonTableHeaders } from 'src/app/interfaces/comparisonTable';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-plan-comparison-table',
  templateUrl: './plan-comparison-table.component.html',
  styleUrl: './plan-comparison-table.component.scss'
})
export class PlanComparisonTableComponent {

  comparisonTableHeaders: comparisonTableHeaders[];
  comparisonTableFeatures: comparisonTableFeature[];
  comparisonTableTitle: string;

  // Path only: the table is anchored with #our-plans, and the pages carry query params.
  private currentPath: string;

  constructor(
    private configService: ConfigService,
    private router: Router,
  ) {
    this.currentPath = this.router.url.split(/[?#]/)[0];
    this.comparisonTableTitle = this.configService.getTextFromKey('comparison-table-title');
    this.comparisonTableHeaders = this.configService.getObjectListFromKey<comparisonTableHeaders>('comparison-table-headers');
    this.comparisonTableFeatures = this.configService.getObjectListFromKey<comparisonTableFeature>('comparison-table-features');
  }

  get gridTemplateColumns(): string {
    return '2fr ' + '1fr '.repeat(this.comparisonTableHeaders.length);
  }

  showLearnMore(plan: comparisonTableHeaders): boolean {
    return !!plan.route && plan.route !== this.currentPath;
  }

  trackByFeatureLabel(_index: number, feature: comparisonTableFeature): string {
    return feature.label;
  }

  trackByPlanName(_index: number, comparisonTableHeaders: comparisonTableHeaders): string {
    return comparisonTableHeaders.name;
  }
}
